function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 0 48 48",
  role: "img"
}, props), /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 24,
  r: 17,
  fill: "#FFF",
  fillRule: "evenodd",
  stroke: "#000",
  strokeOpacity: 0.4,
  strokeWidth: 0.944
}));
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/ic-map-pin-head.svg";
export { SvgComponent as ReactComponent };